import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from 'react';
const useEventListener = (type, listener, options) => {
  const $ = _c(7);
  const ref = useRef(undefined);
  let t0;
  if ($[0] !== listener || $[1] !== options || $[2] !== type) {
    t0 = () => {
      if (ref.current) {
        ref.current.addEventListener(type, listener, options);
        return () => ref.current?.removeEventListener(type, listener, options);
      }
    };
    $[0] = listener;
    $[1] = options;
    $[2] = type;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  let t1;
  if ($[4] !== listener || $[5] !== options) {
    t1 = [listener, options];
    $[4] = listener;
    $[5] = options;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  useEffect(t0, t1);
  return ref;
};
export default useEventListener;